import React, { PureComponent } from 'react';
import { func, number, string } from 'prop-types';
import { Redirect } from 'react-router';
import { PATHS } from 'config/paths';
import { ONBOARDING_STORAGE_KEY } from 'view/Onboarding/onboardingFromUrl';
import ShoppingCartIndexPlaceholder from '../../Index/ShoppingCartIndexPlaceholder';

const readOnboardingFromUrl = () => {
    try {
        const search = global.location.search;
        const match = search.match(/(?:^|\?|&)onboarding=([^&]+)/);
        if (!match) return null;
        return decodeURIComponent(match[1]);
    } catch (error) {
        return null;
    }
};

class ShoppingCartProductAddComponent extends PureComponent {
    static propTypes = {
        addProductToCart: func.isRequired,
        productId: number.isRequired,
        source: string,
    };

    static defaultProps = {
        source: undefined,
    };

    constructor(props) {
        super(props);
        this.state = { loading: true };
    }

    async componentDidMount() {
        const { productId, addProductToCart, source } = this.props;

        const onboarding = readOnboardingFromUrl();
        if (onboarding) {
            localStorage.setItem(ONBOARDING_STORAGE_KEY, onboarding);
        }

        await addProductToCart(productId, source);
        this.setState({ loading: false });
    }

    render() {
        if (this.state.loading) {
            return <ShoppingCartIndexPlaceholder />;
        }

        return (
            <Redirect to={`${PATHS.CART.INDEX}/${global.location.search}`} />
        );
    }
}

export default ShoppingCartProductAddComponent;
